/**
 * Lipirea unei poze din clipboard („print screen" → Ctrl+V, fără salvare în fișier).
 *
 * Logica stă separat de widget ca să poată fi testată fără DOM: browserul dă
 * evenimentul de lipire însoțit de o listă de elemente, iar noi vrem doar imaginea.
 */

export interface ClipboardItemLike {
  kind?: string;
  type?: string;
  getAsFile(): File | null;
}

export interface ClipboardDataLike {
  items?: ArrayLike<ClipboardItemLike> | null;
}

/** Prima imagine din clipboard, dacă vizitatorul a copiat una. Textul nu ne interesează. */
export function imageFromClipboard(data: ClipboardDataLike | null | undefined): File | null {
  const items = data?.items;
  if (!items) return null;
  for (let index = 0; index < items.length; index += 1) {
    const item = items[index];
    if (!item || item.kind !== "file") continue;
    if (!String(item.type ?? "").startsWith("image/")) continue;
    const file = item.getAsFile();
    if (file) return file;
  }
  return null;
}

const EDITABLE_TAGS = new Set(["INPUT", "TEXTAREA", "SELECT"]);

/**
 * Atinge lipirea vreun câmp al paginii? Atunci nu ne băgăm: omul lipește un cod
 * de cupon, o adresă sau un text într-un formular al magazinului, nu o poză.
 */
export function pasteAimedAtPageField(path: readonly unknown[]): boolean {
  return path.some((node) => {
    const element = node as { tagName?: unknown; isContentEditable?: unknown } | null;
    if (!element || typeof element !== "object") return false;
    const tag = String(element.tagName ?? "").toUpperCase();
    if (EDITABLE_TAGS.has(tag)) return true;
    return element.isContentEditable === true;
  });
}
